module.exports = __webpack_public_path__ + "media/images/icons/clients-2436a2aa808718719433505332bc11b3.svg";